import { render, staticRenderFns } from "./changeport.vue?vue&type=template&id=562cea2e"
import script from "./changeport.vue?vue&type=script&lang=js"
export * from "./changeport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports